import { Nullable } from 'types';
import type { DynamicLocationInfo, Funnelable, LocationInfo } from '../types';
import { Funnel } from '../types';
import type { SubscriptionLocations } from './subscription';

export default class SubscriptionLocationsImpl
  implements SubscriptionLocations, Funnelable
{
  pricing: DynamicLocationInfo = {
    pathname: (query: string) => `/pricing${query}`,
    route: '/pricing',
    funnels: [Funnel.Subscription, Funnel.AIMusicGenerator],
  };

  checkout: LocationInfo = {
    pathname: '/checkout',
    funnels: [Funnel.Subscription, Funnel.AIMusicGenerator],
  };

  funnelsForPathname(pathname: string): Nullable<Funnel[]> {
    const { checkout, pricing } = this;
    if (pathname.includes('/pricing')) return pricing.funnels;
    if (pathname.includes('/checkout')) return checkout.funnels;
    return null;
  }
}
